function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M115 9.88281C54.2162 9.88281 4.94141 59.1576 4.94141 119.941C4.94141 140.641 10.6604 160.004 20.5985 176.543L21.7629 176.992H70.4999C72.9953 173.976 76.7652 172.051 80.9766 172.051H149.023C149.062 172.051 149.101 172.053 149.141 172.054V128.477C149.141 127.486 149.947 126.68 150.938 126.68H224.533L224.876 126.23C224.993 124.148 225.059 122.053 225.059 119.941C225.059 59.1576 175.784 9.88281 115 9.88281Z",
  fill: "#C2A1FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M150.938 126.23C149.697 126.23 148.691 127.236 148.691 128.477V172.051H149.023C153.234 172.051 157.004 173.976 159.5 176.992H209.123C218.206 162.036 223.832 144.747 224.876 126.23H150.938Z",
  fill: "#87A6FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M155.987 126.23C154.021 129.965 151.561 133.399 148.691 136.443V171.602H149.023C153.305 171.602 157.137 173.521 159.713 176.543H161.719V128.477C161.719 127.236 162.725 126.23 163.965 126.23H155.987Z",
  fill: "#6C7FD8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M161.045 141.504C162.906 141.504 164.414 139.995 164.414 138.135C164.414 136.274 162.906 134.766 161.045 134.766C159.184 134.766 157.676 136.274 157.676 138.135C157.676 139.995 159.184 141.504 161.045 141.504Z",
  fill: "#D8ECFE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M161.045 153.633C162.906 153.633 164.414 152.124 164.414 150.264C164.414 148.403 162.906 146.895 161.045 146.895C159.184 146.895 157.676 148.403 157.676 150.264C157.676 152.124 159.184 153.633 161.045 153.633Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M172.725 141.504C174.585 141.504 176.094 139.995 176.094 138.135C176.094 136.274 174.585 134.766 172.725 134.766C170.864 134.766 169.355 136.274 169.355 138.135C169.355 139.995 170.864 141.504 172.725 141.504Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M172.725 153.633C174.585 153.633 176.094 152.124 176.094 150.264C176.094 148.403 174.585 146.895 172.725 146.895C170.864 146.895 169.355 148.403 169.355 150.264C169.355 152.124 170.864 153.633 172.725 153.633Z",
  fill: "#D8ECFE"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M198.779 141.504C200.64 141.504 202.148 139.995 202.148 138.135C202.148 136.274 200.64 134.766 198.779 134.766C196.919 134.766 195.41 136.274 195.41 138.135C195.41 139.995 196.919 141.504 198.779 141.504Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M198.779 153.633C200.64 153.633 202.148 152.124 202.148 150.264C202.148 148.403 200.64 146.895 198.779 146.895C196.919 146.895 195.41 148.403 195.41 150.264C195.41 152.124 196.919 153.633 198.779 153.633Z",
  fill: "#D8ECFE"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M210.459 141.504C212.32 141.504 213.828 139.995 213.828 138.135C213.828 136.274 212.32 134.766 210.459 134.766C208.598 134.766 207.09 136.274 207.09 138.135C207.09 139.995 208.598 141.504 210.459 141.504Z",
  fill: "#D8ECFE"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M210.459 153.633C212.32 153.633 213.828 152.124 213.828 150.264C213.828 148.403 212.32 146.895 210.459 146.895C208.598 146.895 207.09 148.403 207.09 150.264C207.09 152.124 208.598 153.633 210.459 153.633Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M187.849 150.305C186.801 150.708 185.668 150.938 184.479 150.938C183.291 150.938 182.158 150.708 181.11 150.305V163.965H187.849V150.305Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M202.448 176.992V165.762C202.448 164.521 201.442 163.516 200.202 163.516H168.757C167.517 163.516 166.511 164.521 166.511 165.762V176.992H202.448Z",
  fill: "#314DC9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M180.137 176.543V165.762C180.137 164.521 181.143 163.516 182.383 163.516H168.757C167.517 163.516 166.511 164.521 166.511 165.762V176.543H180.137Z",
  fill: "#2740B0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M85.5387 165.312V132.52C85.5387 131.279 84.5329 130.273 83.2926 130.273H42.7129C41.4726 130.273 40.4668 131.279 40.4668 132.52V165.312H85.5387Z",
  fill: "#314DC9"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M49.4512 160.371C48.2109 160.371 47.2051 159.365 47.2051 158.125V139.258C47.2051 138.018 48.2109 137.012 49.4512 137.012H54.6922V132.52C54.6922 131.279 55.698 130.273 56.9383 130.273H42.7129C41.4726 130.273 40.4668 131.279 40.4668 132.52V164.863H54.6922V160.371H49.4512Z",
  fill: "#2740B0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M47.2051 158.125V139.258C47.2051 138.018 48.2109 137.012 49.4512 137.012H76.5539C77.7942 137.012 78.8 138.018 78.8 139.258V158.125C78.8 159.365 77.7942 160.371 76.5539 160.371H49.4512C48.2109 160.371 47.2051 159.365 47.2051 158.125Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M80.9772 172.051H99.3152V167.109C99.3152 165.869 98.3094 164.863 97.0692 164.863H28.9375C27.6972 164.863 26.6914 165.869 26.6914 167.109V176.992H70.5006C72.9955 173.976 76.7658 172.051 80.9772 172.051Z",
  fill: "#87A6FF"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M45.5586 176.543V167.109C45.5586 165.869 46.5644 164.863 47.8047 164.863H28.9375C27.6972 164.863 26.6914 165.869 26.6914 167.109V176.543H45.5586Z",
  fill: "#6C7FD8"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5986 176.543C31.5677 194.798 47.682 209.608 66.9338 218.971L67.383 218.691V185.645C67.383 182.147 68.7113 178.955 70.8896 176.543H20.5986Z",
  fill: "#4F66D0"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M159.11 176.543C161.288 178.954 162.617 182.147 162.617 185.645V218.691L163.066 218.971C182.318 209.607 198.432 194.798 209.401 176.543H159.11Z",
  fill: "#4F66D0"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M192.266 107.812H37.7344C36.4941 107.812 35.4883 106.807 35.4883 105.566V2.24609C35.4883 1.0058 36.4941 0 37.7344 0H192.266C193.506 0 194.512 1.0058 194.512 2.24609V105.566C194.512 106.807 193.506 107.812 192.266 107.812Z",
  fill: "#E8EDF2"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M53.457 105.566V92.5391H45.9344C44.7197 92.5391 43.735 91.5544 43.735 90.3397V9.83609C43.735 8.62141 44.7197 7.63672 45.9344 7.63672H53.457V2.24609C53.457 1.0058 54.4628 0 55.7031 0H37.7344C36.4941 0 35.4883 1.0058 35.4883 2.24609V105.566C35.4883 106.807 36.4941 107.812 37.7344 107.812H55.7031C54.4628 107.812 53.457 106.807 53.457 105.566Z",
  fill: "#D9E7EC"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M43.7354 90.3397V9.83609C43.7354 8.62141 44.72 7.63672 45.9347 7.63672H184.066C185.281 7.63672 186.265 8.62141 186.265 9.83609V90.3392C186.265 91.5539 185.281 92.5386 184.066 92.5386H45.9347C44.72 92.5391 43.7354 91.5544 43.7354 90.3397Z",
  fill: "#87A6FF"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8215 90.3397V9.83609C57.8215 8.62141 58.8062 7.63672 60.0209 7.63672H45.9347C44.72 7.63672 43.7354 8.62141 43.7354 9.83609V90.3392C43.7354 91.5539 44.72 92.5386 45.9347 92.5386H60.0209C58.8062 92.5391 57.8215 91.5544 57.8215 90.3397Z",
  fill: "#6C7FD8"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M174.521 60.418H140.096C138.855 60.418 137.85 59.4122 137.85 58.1719V55.9258C137.85 54.6855 138.855 53.6797 140.096 53.6797H174.521C175.761 53.6797 176.767 54.6855 176.767 55.9258V58.1719C176.767 59.4122 175.761 60.418 174.521 60.418Z",
  fill: "#2740B0"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M130.107 60.418H112.529C111.289 60.418 110.283 59.4122 110.283 58.1719V55.9258C110.283 54.6855 111.289 53.6797 112.529 53.6797H130.107C131.347 53.6797 132.353 54.6855 132.353 55.9258V58.1719C132.353 59.4122 131.347 60.418 130.107 60.418Z",
  fill: "#2740B0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M173.007 74.5703C174.868 74.5703 176.376 73.0619 176.376 71.2012C176.376 69.3404 174.868 67.832 173.007 67.832C171.146 67.832 169.638 69.3404 169.638 71.2012C169.638 73.0619 171.146 74.5703 173.007 74.5703Z",
  fill: "#2740B0"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M163.573 74.5703C165.434 74.5703 166.942 73.0619 166.942 71.2012C166.942 69.3404 165.434 67.832 163.573 67.832C161.713 67.832 160.204 69.3404 160.204 71.2012C160.204 73.0619 161.713 74.5703 163.573 74.5703Z",
  fill: "#2740B0"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M154.14 74.5703C156 74.5703 157.509 73.0619 157.509 71.2012C157.509 69.3404 156 67.832 154.14 67.832C152.279 67.832 150.771 69.3404 150.771 71.2012C150.771 73.0619 152.279 74.5703 154.14 74.5703Z",
  fill: "#2740B0"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M70.752 74.5703C72.6127 74.5703 74.1211 73.0619 74.1211 71.2012C74.1211 69.3404 72.6127 67.832 70.752 67.832C68.8912 67.832 67.3828 69.3404 67.3828 71.2012C67.3828 73.0619 68.8912 74.5703 70.752 74.5703Z",
  fill: "#2740B0"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M59.0723 74.5703C60.933 74.5703 62.4414 73.0619 62.4414 71.2012C62.4414 69.3404 60.933 67.832 59.0723 67.832C57.2115 67.832 55.7031 69.3404 55.7031 71.2012C55.7031 73.0619 57.2115 74.5703 59.0723 74.5703Z",
  fill: "#2740B0"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M114.34 58.403C88.9257 58.757 68.3923 79.8649 68.7077 105.28C68.9 120.779 76.7096 134.443 88.5654 142.704C91.63 144.839 94.1375 147.678 96.0049 150.912L100.927 159.438H129.072L134.043 150.828C135.885 147.638 138.361 144.839 141.387 142.737C153.418 134.376 161.295 120.456 161.295 104.695C161.295 78.9063 140.211 58.0428 114.34 58.403Z",
  fill: "#A2E62E"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0053 150.913L100.668 158.989H122.15L114.846 146.339C112.979 143.105 110.472 140.265 107.407 138.13C95.5512 129.87 87.7415 116.206 87.5492 100.707C87.3201 82.2216 98.1216 66.0179 113.807 58.418C88.64 59.0577 68.395 80.0438 68.7077 105.28C68.8999 120.78 76.7096 134.444 88.5654 142.704C91.6304 144.839 94.1379 147.678 96.0053 150.913Z",
  fill: "#97D729"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M138.69 172.051V162.696C138.69 160.648 137.029 158.988 134.982 158.988H95.0174C92.9694 158.988 91.3096 160.649 91.3096 162.696V172.051H138.69Z",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M110.058 171.601V162.696C110.058 160.648 111.718 158.988 113.766 158.988H95.0174C92.9694 158.988 91.3096 160.649 91.3096 162.696V171.601H110.058Z",
  fill: "#F5F8F9"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M149.023 171.602H80.9771C73.2209 171.602 66.9336 177.889 66.9336 185.645V218.973C81.4573 226.035 97.7648 230 115 230C132.235 230 148.543 226.035 163.066 218.973V185.645C163.066 177.889 156.779 171.602 149.023 171.602Z",
  fill: "#E8EDF2"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M89.3945 185.645C89.3945 177.889 95.6818 171.602 103.438 171.602H80.9771C73.2209 171.602 66.9336 177.889 66.9336 185.645V218.973C74.0272 222.422 81.5494 225.126 89.3945 226.997V185.645Z",
  fill: "#D9E7EC"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M184.479 151.387C189.938 151.387 194.362 146.962 194.362 141.504C194.362 136.046 189.938 131.621 184.479 131.621C179.021 131.621 174.597 136.046 174.597 141.504C174.597 146.962 179.021 151.387 184.479 151.387Z",
  fill: "#FE646F"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M181.035 141.504C181.035 137.173 183.821 133.496 187.698 132.16C186.689 131.812 185.606 131.621 184.479 131.621C179.021 131.621 174.596 136.046 174.596 141.504C174.596 146.962 179.021 151.387 184.479 151.387C185.606 151.387 186.688 151.195 187.698 150.848C183.821 149.512 181.035 145.834 181.035 141.504Z",
  fill: "#FD4755"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M96.0623 30.2261H88.7845C87.263 30.2261 86.0249 28.9881 86.0249 27.4666C86.0249 25.9451 87.263 24.707 88.7849 24.707H92.8814L92.6226 24.2578C88.5437 19.3196 82.3737 16.1719 75.4688 16.1719C63.188 16.1719 53.2324 26.1275 53.2324 38.4082C53.2324 50.6889 63.188 60.6445 75.4688 60.6445C87.7495 60.6445 97.7051 50.6889 97.7051 38.4082C97.7051 35.6886 97.215 33.0841 96.3215 30.6754L96.0623 30.2261Z",
  fill: "#314DC9"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M62.4414 38.4082C62.4414 27.7105 69.9964 18.7805 80.0611 16.6548C78.5787 16.3435 77.0442 16.1719 75.4688 16.1719C63.188 16.1719 53.2324 26.1275 53.2324 38.4082C53.2324 50.6889 63.188 60.6445 75.4688 60.6445C77.0478 60.6445 78.5872 60.4774 80.0732 60.1643C70.0027 58.0436 62.4414 49.1099 62.4414 38.4082Z",
  fill: "#2740B0"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M92.6222 24.2578H88.7849C87.0128 24.2578 85.5762 25.6944 85.5762 27.4666C85.5762 29.2387 87.0128 30.6754 88.7849 30.6754H96.3215C95.4486 28.3228 94.1908 26.1576 92.6222 24.2578Z",
  fill: "#97D729"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M86.6992 38.2478C86.6992 36.4757 85.2626 35.0391 83.4904 35.0391H80.0252C78.253 35.0391 76.8164 36.4757 76.8164 38.2478C76.8164 40.02 78.253 41.4566 80.0252 41.4566H83.4904C85.2626 41.4566 86.6992 40.02 86.6992 38.2478Z",
  fill: "#97D729"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M72.3242 31.5096C72.3242 29.7374 70.8876 28.3008 69.1154 28.3008H65.6502C63.878 28.3008 62.4414 29.7374 62.4414 31.5096C62.4414 33.2817 63.878 34.7183 65.6502 34.7183H69.1154C70.8876 34.7183 72.3242 33.2817 72.3242 31.5096Z",
  fill: "#97D729"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M76.3029 45.6914H66.9978C65.2257 45.6914 63.7891 47.128 63.7891 48.9002C63.7891 50.6723 65.2257 52.1089 66.9978 52.1089H76.3029C78.0751 52.1089 79.5117 50.6723 79.5117 48.9002C79.5117 47.128 78.0751 45.6914 76.3029 45.6914Z",
  fill: "#97D729"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M146.782 27.6562H136.001C134.761 27.6562 133.755 26.6504 133.755 25.4102V23.1641C133.755 21.9238 134.761 20.918 136.001 20.918H146.782C148.023 20.918 149.028 21.9238 149.028 23.1641V25.4102C149.028 26.6504 148.023 27.6562 146.782 27.6562Z",
  fill: "#2740B0"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M174.522 27.6562H157.775C156.535 27.6562 155.529 26.6504 155.529 25.4102V23.1641C155.529 21.9238 156.535 20.918 157.775 20.918H174.522C175.762 20.918 176.768 21.9238 176.768 23.1641V25.4102C176.768 26.6504 175.762 27.6562 174.522 27.6562Z",
  fill: "#2740B0"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M174.521 44.2422H136.535C135.295 44.2422 134.289 43.2364 134.289 41.9961V39.75C134.289 38.5097 135.295 37.5039 136.535 37.5039H174.521C175.761 37.5039 176.767 38.5097 176.767 39.75V41.9961C176.767 43.2364 175.761 44.2422 174.521 44.2422Z",
  fill: "#2740B0"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M116.685 44.6992C109.378 44.6992 103.433 38.7543 103.433 31.4473C103.433 24.1403 109.378 18.1953 116.685 18.1953C123.992 18.1953 129.937 24.1403 129.937 31.4473C129.937 38.7543 123.992 44.6992 116.685 44.6992ZM116.685 24.9336C113.093 24.9336 110.171 27.8558 110.171 31.4473C110.171 35.0388 113.093 37.9609 116.685 37.9609C120.276 37.9609 123.198 35.0388 123.198 31.4473C123.198 27.8558 120.276 24.9336 116.685 24.9336Z",
  fill: "#2740B0"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M116.685 34.8164C118.545 34.8164 120.054 33.308 120.054 31.4473C120.054 29.5865 118.545 28.0781 116.685 28.0781C114.824 28.0781 113.315 29.5865 113.315 31.4473C113.315 33.308 114.824 34.8164 116.685 34.8164Z",
  fill: "#2740B0"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M72.4365 147.344C74.2972 147.344 75.8057 145.835 75.8057 143.975C75.8057 142.114 74.2972 140.605 72.4365 140.605C70.5758 140.605 69.0674 142.114 69.0674 143.975C69.0674 145.835 70.5758 147.344 72.4365 147.344Z",
  fill: "#2740B0"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M63.0029 147.344C64.8637 147.344 66.3721 145.835 66.3721 143.975C66.3721 142.114 64.8637 140.605 63.0029 140.605C61.1422 140.605 59.6338 142.114 59.6338 143.975C59.6338 145.835 61.1422 147.344 63.0029 147.344Z",
  fill: "#87A6FF"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5693 147.344C55.4301 147.344 56.9385 145.835 56.9385 143.975C56.9385 142.114 55.4301 140.605 53.5693 140.605C51.7086 140.605 50.2002 142.114 50.2002 143.975C50.2002 145.835 51.7086 147.344 53.5693 147.344Z",
  fill: "#2740B0"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M63.0029 156.328C64.8637 156.328 66.3721 154.82 66.3721 152.959C66.3721 151.098 64.8637 149.59 63.0029 149.59C61.1422 149.59 59.6338 151.098 59.6338 152.959C59.6338 154.82 61.1422 156.328 63.0029 156.328Z",
  fill: "#2740B0"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5693 156.328C55.4301 156.328 56.9385 154.82 56.9385 152.959C56.9385 151.098 55.4301 149.59 53.5693 149.59C51.7086 149.59 50.2002 151.098 50.2002 152.959C50.2002 154.82 51.7086 156.328 53.5693 156.328Z",
  fill: "#87A6FF"
});

var SvgIcCockpit = function SvgIcCockpit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCockpit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_cockpit.fb68462e.svg";
export { ForwardRef as ReactComponent };